/* =============================================
   AURUM BREW — Customer care & policy pages
   Loaded from layout/theme.liquid on the six policy handles only.

   Assembles the chrome from snippets/aurum-policy-chrome.liquid around the
   page body that Shopify renders, then builds the contents list from the
   headings actually present in that body.

   The policy text is never touched. It stays exactly as authored in the page
   record, which is what keeps it selectable, searchable and indexable.
   ============================================= */
(function () {
  'use strict';

  var build = function () {
    var host = document.getElementById('apol-host');
    if (!host) return;

    var title = document.querySelector('.main-page-title');
    var rte = document.querySelector('.rte');
    var column = title ? title.parentNode : (rte ? rte.parentNode : null);
    if (!column || !rte || column.dataset.apolDone) return;
    column.dataset.apolDone = '1';

    var wantsToc = host.getAttribute('data-toc') === 'true';

    /* Shopify's page section prints its own H1. The hero carries one too, and
       two H1s on a page is both a heading-order fault and an SEO smell, so
       the section's copy goes. */
    if (title) title.remove();

    column.classList.add('apol');
    column.classList.remove('page-width--narrow');
    if (column.parentNode) column.parentNode.classList.add('apol-bg');

    var hero = host.querySelector('.apol-hero');
    var notes = host.querySelector('[data-slot="notes"]');
    var help = host.querySelector('[data-slot="help"]');
    var related = host.querySelector('[data-slot="related"]');

    /* ── frame ── */
    var body = document.createElement('div');
    body.className = 'apol-body' + (wantsToc ? ' apol-body--toc' : '');
    var doc = document.createElement('div');
    doc.className = 'apol-doc';

    rte.parentNode.insertBefore(body, rte);
    if (notes) doc.appendChild(notes);
    doc.appendChild(rte);

    var toc = wantsToc ? buildToc(rte) : null;
    if (toc) body.appendChild(toc);
    body.appendChild(doc);

    if (hero) column.insertBefore(hero, body);
    if (help) column.appendChild(help);
    if (related) column.appendChild(related);
    host.remove();

    if (toc) spy(toc, rte);
    faqDeepLink();
  };

  /* ── contents ────────────────────────────────────────────────────────
     Built from the headings that are really in the body, so it can never
     drift from the document the way a hand-maintained list would. */
  var buildToc = function (rte) {
    var heads = rte.querySelectorAll('h2[id]');
    if (heads.length < 3) return null;

    var aside = document.createElement('aside');
    aside.className = 'apol-toc';

    var wrap = document.createElement('details');
    wrap.className = 'apol-toc__mobile';
    /* open on desktop where it reads as a plain sticky list; collapsed on
       small screens so it costs one line until asked for */
    if (!window.matchMedia || window.matchMedia('(min-width: 900px)').matches) {
      wrap.open = true;
    }

    var sum = document.createElement('summary');
    sum.textContent = 'Contents';
    wrap.appendChild(sum);

    var lbl = document.createElement('p');
    lbl.className = 'apol-toc__title';
    lbl.textContent = 'Contents';
    wrap.appendChild(lbl);

    var ol = document.createElement('ol');
    for (var i = 0; i < heads.length; i++) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + heads[i].id;
      a.textContent = (heads[i].textContent || '').trim();
      li.appendChild(a);
      ol.appendChild(li);
    }
    wrap.appendChild(ol);
    aside.appendChild(wrap);

    /* on a phone, choosing a section should close the list behind you */
    ol.addEventListener('click', function () {
      if (window.matchMedia && !window.matchMedia('(min-width: 900px)').matches) {
        wrap.open = false;
      }
    });
    return aside;
  };

  /* Marks the section you are reading. Purely decorative — the links work
     with or without it, and it is skipped where IntersectionObserver is not
     available rather than faked with scroll maths. */
  var spy = function (aside, rte) {
    if (!('IntersectionObserver' in window)) return;
    var links = {};
    var all = aside.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < all.length; i++) {
      links[decodeURIComponent(all[i].getAttribute('href').slice(1))] = all[i];
    }
    var seen = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var id = e.target.id;
        var at = seen.indexOf(id);
        if (e.isIntersecting && at === -1) seen.push(id);
        if (!e.isIntersecting && at !== -1) seen.splice(at, 1);
      });
      var current = seen[0];
      for (var k in links) {
        if (links[k]) links[k].classList.toggle('is-current', k === current);
      }
    }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });

    var heads = rte.querySelectorAll('h2[id]');
    for (var j = 0; j < heads.length; j++) io.observe(heads[j]);
  };

  /* A link to a single question should open it, not drop the reader on a
     closed row with no visible answer. */
  var faqDeepLink = function () {
    var open = function () {
      var id = (window.location.hash || '').slice(1);
      if (!id) return;
      var el = document.getElementById(decodeURIComponent(id));
      if (!el) return;
      if (el.tagName === 'DETAILS') el.open = true;
      var d = el.closest ? el.closest('details.apol-q') : null;
      if (d) d.open = true;
      /* re-run the jump: the row was closed when the browser first tried */
      window.setTimeout(function () {
        var t = el.getBoundingClientRect().top + window.pageYOffset - 100;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: t, behavior: reduce ? 'auto' : 'smooth' });
      }, 60);
    };
    open();
    window.addEventListener('hashchange', open);
  };

  /* ------------------------------------------------------------------
     Reveal.

     layout/theme.liquid puts html.apol-wait up before the body parses, so
     the page is held blank rather than showing Shopify's raw layout — the
     h0 title and unstyled body — for the moment before this file rearranges
     it into .apol.

     This runs in a finally, not at the end of build(). build() returns early
     in several places (no host, no rte, already assembled), and on any of
     those paths the page must still be revealed. Tying the reveal to success
     would mean the one situation where the layout is broken is also the
     situation where nothing is visible at all.

     theme.liquid carries its own timeout as a second net, in case this file
     never loads.
     ------------------------------------------------------------------ */
  var revealed = false;
  var reveal = function () {
    if (revealed) return;
    revealed = true;
    document.documentElement.classList.remove('apol-wait');
  };

  var run = function () {
    try {
      build();
    } finally {
      /* Wait a frame so the assembled layout and the fade-in paint together
         rather than revealing a half-built page — but race that against a
         plain timer, because requestAnimationFrame does not run in a
         background tab. A policy page opened in a new tab, or left while it
         loaded, would otherwise sit blank on rAF that never fires until the
         tab is looked at. Whichever lands first wins; reveal is idempotent.

         This is the second time this pattern has bitten this theme — the
         story-pillar glide in anchor-glide.js needed the same pairing. */
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(reveal);
        });
      }
      window.setTimeout(reveal, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
